import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AudienceLab from "@/pages/admin/AudienceLab";

export const Route = createFileRoute("/admin/audience-lab")({
  head: () => pageHead("Admin \u2014 Audience Lab \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AudienceLab,
});
